import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { tenant } from "@/api";
import { useAuth } from "@/context/AuthContext";

/**
 * Provides the tenant branding (name + logo URL) to the whole authenticated app.
 * Falls back to user.tenant.name + no logo until the /tenant/branding call returns.
 */
const TenantBrandingContext = createContext({ name: "", logoUrl: "", refresh: async () => {} });

export function TenantBrandingProvider({ children }) {
  const { user } = useAuth();
  const [branding, setBranding] = useState({ name: "", logoUrl: "" });

  const refresh = useCallback(async () => {
    if (!user) return;
    try {
      const data = await tenant.getBranding();
      setBranding({ name: data.name || "", logoUrl: data.logoUrl || "" });
    } catch {
      setBranding({ name: user.tenant?.name || "", logoUrl: "" });
    }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <TenantBrandingContext.Provider value={{ ...branding, refresh }}>
      {children}
    </TenantBrandingContext.Provider>
  );
}

export function useTenantBranding() {
  return useContext(TenantBrandingContext);
}
